const MENU = {
  PARAMETERS: "parameters",
  ORGANIZATIONS: "organizations",
  SITE: "site",
  HOME: "home"
}

export { MENU }
